var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M9.78672 18.1254C7.43599 18.2766 5.30263 19.1719 4.09211 22.3617C3.95442 22.7256 3.62337 22.9465 3.23724 22.9465C2.58628 22.9465 0.573622 21.3252 0 20.9338C0.000585926 25.759 2.223 30 7.50044 30C11.9453 30 15.0003 27.4354 15.0003 22.9576C15.0003 22.7754 14.9622 22.6014 14.9435 22.4227L9.78672 18.1254V18.1254ZM26.8296 0C25.9413 0 25.1087 0.393164 24.4735 0.963867C12.4966 11.6631 11.2504 11.9145 11.2504 15.0639C11.2504 15.8666 11.4408 16.6318 11.7619 17.3314L15.5013 20.4475C15.9237 20.5529 16.3591 20.625 16.8131 20.625C20.4523 20.625 22.5617 17.9607 29.1856 5.59805C29.618 4.75723 30 3.84902 30 2.90332C30 1.20937 28.4766 0 26.8296 0Z",
          fill: "currentColor"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }